import { useState, useEffect } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { FiMail, FiLock, FiArrowRight } from 'react-icons/fi'
import { FaFacebook } from 'react-icons/fa'
import toast from 'react-hot-toast'
import useAuthStore from '../stores/authStore'
import { getFacebookAuthUrl } from '../services/api'

export default function LoginPage() {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const { login, isLoading, setToken } = useAuthStore()
    const navigate = useNavigate()
    const location = useLocation()

    const redirectTo = location.state?.from?.pathname ||
        new URLSearchParams(location.search).get('redirect') || '/'

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search)
        const token = queryParams.get('token')
        const error = queryParams.get('error')

        if (token) {
            setToken(token).then(() => {
                toast.success(window.t('uspesheн_vhod_s_facebook'))
                navigate(redirectTo)
            })
        }
        if (error) {
            toast.error(window.t('neuspeshno_udostoveryavane_chrez_facebook'))
        }
    }, [location.search, setToken, navigate, redirectTo])

    const handleFacebookLogin = async () => {
        try {
            const response = await getFacebookAuthUrl()
            window.location.href = response.data.url
        } catch (error) {
            toast.error(window.t('neuspeshno_svarzvane_s_facebook'))
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        const result = await login(email, password)

        if (result.success) {
            toast.success(window.t('dobre_doshli_otnovo'))
            navigate(redirectTo)
        } else {
            toast.error(result.error)
        }
    }

    return (
        <div className="min-h-screen pt-16 flex items-center justify-center px-4">
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary-500/10 rounded-full blur-3xl" />
                <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-accent-500/10 rounded-full blur-3xl" />
            </div>

            <div className="card p-8 w-full max-w-md relative">
                <div className="text-center mb-8">
                    <h1 className="text-2xl font-bold text-white">{window.t('dobre_doshli_otnovo')}</h1>
                    <p className="text-gray-400 mt-2">{window.t('vlezte_za_da_prodalzhite_kam_t')}</p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label className="label">{window.t('imeyl')}</label>
                        <div className="relative">
                            <FiMail className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500" />
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="input pl-12"
                                placeholder="you@example.com"
                                required
                            />
                        </div>
                    </div>

                    <div>
                        <label className="label">{window.t('parola')}</label>
                        <div className="relative">
                            <FiLock className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500" />
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="input pl-12"
                                placeholder="••••••••"
                                required
                            />
                        </div>
                    </div>

                    <div className="flex items-center justify-between text-sm">
                        <label className="flex items-center gap-2 text-gray-400">
                            <input type="checkbox" className="rounded bg-gray-800 border-gray-700" />
                            {window.t('zapomni_me')}
                        </label>
                        <a href="#" className="text-primary-400 hover:text-primary-300">
                            {window.t('zabravena_parola')}
                        </a>
                    </div>

                    <button
                        type="submit"
                        className="btn-primary w-full"
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-white"></div>
                        ) : (
                            <>
                                {window.t('vhod')}
                                <FiArrowRight className="w-4 h-4 ml-2" />
                            </>
                        )}
                    </button>

                    <div className="relative my-6">
                        <div className="absolute inset-0 flex items-center">
                            <div className="w-full border-t border-gray-700"></div>
                        </div>
                        <div className="relative flex justify-center text-sm">
                            <span className="px-2 bg-gray-900 text-gray-400">{window.t('ili_prodalzhete_s')}</span>
                        </div>
                    </div>

                    <button
                        type="button"
                        onClick={handleFacebookLogin}
                        className="w-full flex items-center justify-center gap-2 px-4 py-2 border border-blue-600/50 hover:bg-blue-600/10 text-white rounded-lg transition-colors"
                    >
                        <FaFacebook className="w-5 h-5 text-blue-500" />
                        Facebook
                    </button>
                </form>

                <p className="text-center text-gray-400 mt-6">
                    {window.t('nyamate_profil')}{' '}
                    <Link to="/register" className="text-primary-400 hover:text-primary-300 font-medium">
                        {window.t('registratsiya')}
                    </Link>
                </p>
            </div>
        </div>
    )
}
